export function purchaseTag(obj) {
  window.gtag("event", "purchase", obj);
}
